export interface InstructorSampleRouteParams {
  isHEInstructor: boolean;
  isMhpPdp: boolean;
  isHeStorePurchaseFlow: boolean;
}

export function shouldUseInstructorSampleCartFlow({
  isHEInstructor,
  isMhpPdp,
  isHeStorePurchaseFlow,
}: InstructorSampleRouteParams): boolean {
  return isHEInstructor && !isMhpPdp && !isHeStorePurchaseFlow;
}
